import { render } from "./AttendeeDeleteDrawer.vue?vue&type=template&id=2289cbc9&scoped=true"
import script from "./AttendeeDeleteDrawer.vue?vue&type=script&lang=js"
export * from "./AttendeeDeleteDrawer.vue?vue&type=script&lang=js"

import "./AttendeeDeleteDrawer.vue?vue&type=style&index=0&id=2289cbc9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2289cbc9"]])

export default __exports__